import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Agent } from 'src/types/agents.ts';
import { getDisplayAmount, shortenNumber } from 'src/utils/bigNumber.ts';

export const AgentsTable: FC<{ agents: Agent[] }> = ({ agents }) => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: `${agents.length * 100 + 88}px` }} className="overflow-x-auto">
      <table className="mt-4 w-auto min-w-full max-w-none whitespace-nowrap text-left">
        <thead>
          <tr>
            <th scope="col" className="min-w-48 pb-3">
              Towards AGI
            </th>
            <th scope="col" className="min-w-48 pb-3">
              Description
            </th>
            <th scope="col" className="min-w-32 pb-3">
              Type
            </th>
            <th scope="col" className="min-w-32 pb-3">
              MCAP
            </th>
            <th scope="col" className="min-w-32 pb-3">
              Ticker
            </th>
            {/* <th scope="col" className="min-w-32 pb-3">
              24H Vol
            </th> */}
            <th scope="col" className="min-w-24 pb-3">
              Holders
            </th>
            <th scope="col" className="min-w-24 pb-3">
              Requests
            </th>
          </tr>
        </thead>
        <tbody>
          {agents.map((agent) => (
            <tr
              onClick={() => navigate(`/agents/${agent.agent_id}`)}
              key={agent.agent_id}
              className="cursor-pointer odd:bg-[#191C1E] even:bg-transparent"
            >
              <td className="rounded-bl-2xl rounded-tl-2xl py-3 pl-3">
                <div className="flex items-center gap-4">
                  <div className="h-[76px] w-[76px] overflow-hidden rounded-3xl">
                    <img
                      src={agent.image_url}
                      className="h-full w-full object-cover"
                      alt={agent.name}
                    />
                  </div>
                  <h2 className="text-xl text-white">{agent.name}</h2>
                </div>
              </td>
              <td className="max-w-48 overflow-hidden text-ellipsis whitespace-nowrap py-3 text-sm text-gray-400">
                {agent.description}
              </td>
              <td className="py-3">
                <div className="flex max-w-fit flex-wrap gap-2 rounded-full bg-[#262729] px-3 py-2 text-sm text-white">
                  {agent.origin.map((origin) => (
                    <span key={origin}>{origin}</span>
                  ))}
                </div>
              </td>
              <td className="py-3 text-white">
                ${shortenNumber(agent.token_info?.market_cap_usd)}
              </td>
              <td className="max-w-32 overflow-hidden text-ellipsis whitespace-nowrap py-3 text-sm">
                ${agent.ticker}
              </td>
              {/* <td className="py-3 text-white">
                ${shortenNumber(getDisplayAmount(agent.token_info?.volume_24))}
              </td> */}
              <td className="py-3 text-white">
                {shortenNumber(
                  getDisplayAmount(agent.token_info?.holder_count || 0, { decimals: 0 }),
                  0,
                )}
              </td>
              <td className="rounded-br-2xl rounded-tr-2xl py-3 pr-3 text-white">
                {shortenNumber(getDisplayAmount(agent.request_count || 0, { decimals: 0 }), 0)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
